import type { EventPageFragment } from '@graphql/generated';
import { EventPageType } from '@graphql/generated';

type PageInput = Pick<EventPageFragment, 'disabled' | 'type'>;

/**
 * Filters pages to only include enabled pages (non-disabled, non-app type).
 * Returns the enabled pages list and whether the navigation bar should be shown.
 */
export function getEnabledPages(pages?: ReadonlyArray<PageInput>) {
  const enabledPages = pages?.filter(page => !page.disabled && page.type !== EventPageType.app) ?? [];
  return {
    enabledPages,
    showNavigationBar: enabledPages.length > 1,
  } as const;
}
